import Swiper, {
  Autoplay,
  Navigation,
  Mousewheel,
  Controller,
  Thumbs,
  FreeMode,
} from 'swiper'

const Slider = () => {
  let sliderYear = new Swiper('.timeline-year-slider', {
    modules: [Autoplay, Mousewheel, Controller, FreeMode],
    freeMode: true,
    loop: true,
    watchSlidesProgress: true,
    slidesPerView: 3.6,
  })

  let swiper = new Swiper('.timeline-slider', {
    modules: [Autoplay, Navigation, Controller, Thumbs, FreeMode],

    slidesPerView: 'auto',
    spaceBetween: 120,
    loop: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.timeline-navigation .slider-button-next',
      prevEl: '.timeline-navigation .slider-button-prev',
    },

    thumbs: {
      swiper: sliderYear,
    },
  })

  let years = document.querySelectorAll('[data-slide]')
}

export default Slider
